import { RemoteConfig } from '../services/RemoteLoader';
import { getEnvVar } from '../utils/envUtils';

/**
 * remoteEntry.js has a fixed filename across deploys (Module Federation
 * requires a stable entry point), unlike the content-hashed chunks it
 * points to. That means browsers/CDNs can keep serving a stale cached
 * remoteEntry.js after a new aidi deploy, so users only see the update
 * after a hard refresh. Appending a per-load cache-busting query param
 * forces a fresh fetch every time the remote is (re)loaded, regardless of
 * upstream cache-control headers.
 */
const withCacheBuster = (url: string): string => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${Date.now()}`;
};

/**
 * Predefined remote configurations
 */
export const REMOTE_CONFIGS: Record<string, RemoteConfig> = {
  aidi: {
    url: () => Promise.resolve(withCacheBuster(getEnvVar('VITE_AIDI_REMOTE_URL', '/aidi/assets/remoteEntry.js'))),
  },
  // Add more remotes here as needed
  // example: {
  //   url: getEnvVar('VITE_EXAMPLE_REMOTE_URL', '/example/assets/remoteEntry.js'),
  // },
};
